module.exports = __webpack_public_path__ + "static/media/boy-head.56a3a557.png";